import { Comment } from "../pages/DashBoard/partials/Feed/types/types";

export const getParsedArray = (array: string | Comment[] | number[]) => {
  if (array === 'null') return [];
  if (typeof array === "string") {
    const parsedArray = JSON.parse(array);
    return parsedArray;
  }
  return [];
};
